'use strict';

module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/chart.js/src/charts/Chart.Line.js
// module id = ../../../../chart.js/src/charts/Chart.Line.js
// module chunks = 5